import { Layout, Menu } from "antd";
import {
  DashboardOutlined,
  FileTextOutlined,
  PlusOutlined,
  RobotOutlined,
  CalendarOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Sider } = Layout;

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: "/",
      icon: <BookOutlined />,
      label: "Catalogo Referencias",
    },
    {
      key: "/dashboard",
      icon: <DashboardOutlined />,
      label: "Dashboard",
    },
    {
      key: "/new-case",
      icon: <PlusOutlined />,
      label: "Nuevo Caso",
    },
    {
      key: "/ai-assistant",
      icon: <RobotOutlined />,
      label: "Asistente IA",
    },
    {
      key: "deadlines",
      icon: <CalendarOutlined />,
      label: "Plazos",
    },
    {
      key: "documents",
      icon: <FileTextOutlined />,
      label: "Documentos",
    },
  ];

  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="0"
      style={{
        overflow: "auto",
        height: "100vh",
        position: "sticky",
        top: 0,
        left: 0,
      }}
    >
      <div
        style={{
          height: 64,
          margin: 16,
          background: "rgba(255, 255, 255, 0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontSize: "20px",
          fontWeight: "bold",
        }}
      >
        ⚖️ Legal AI
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={({ key }) => navigate(key)}
      />
    </Sider>
  );
};

export default Sidebar;
